import { render, staticRenderFns } from "./SidebarTitle.vue?vue&type=template&id=beab73fc&scoped=true"
import script from "./SidebarTitle.vue?vue&type=script&lang=js"
export * from "./SidebarTitle.vue?vue&type=script&lang=js"
import style0 from "./SidebarTitle.vue?vue&type=style&index=0&id=beab73fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beab73fc",
  null
  
)

export default component.exports